import { ReactElement, useEffect } from 'react';
import { Grid, SelectChangeEvent, useEventCallback } from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { useFormikContext } from 'formik';
import { DatePicker } from '@mui/lab';
import PmiTextField from 'shell/components/shared/text-field';
import ListRegister from 'civil-status/components/shared/list-register';
import { ResearchNotifications } from 'civil-status/view-models/notifications-list';
import ListTypeContent from 'civil-status/components/shared/list-type-content';
import ListAnsc from 'civil-status/components/shared/list-ansc';
import { ItemVM } from 'shell/view-models/item';

interface FormFilter {
  idCat?: string;
}

const FormFilter = ({ idCat }: FormFilter): ReactElement => {
  const formContext = useFormikContext<ResearchNotifications>();

  useEffect(() => {
    formContext.setFieldValue('typeEvent', idCat);
  }, [idCat]);

  const onChangeRegister = useEventCallback((event: SelectChangeEvent<string>) => {
    formContext.setFieldValue('typeEvent', event.target.value);
  });

  const onChangeTypeContent = useEventCallback((event: SelectChangeEvent<string>) => {
    formContext.setFieldValue('typeContent', event.target.value);
  });

  const handleStateNotification = useEventCallback((item?: ItemVM) => {
    formContext.setFieldValue('stateNotification', item?.id?.toString());
  });

  const handleTypeNotifications = useEventCallback((item?: ItemVM) => {
    formContext.setFieldValue('typeNotifications', item?.id?.toString());
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={3}>
        <ListRegister
          value={formContext.values.typeEvent || ''}
          disabled={formContext.values.disabledTypeEvent || Boolean(idCat)}
          error={Boolean(formContext.errors.typeEvent) && formContext.touched.typeEvent}
          onChange={onChangeRegister}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data inizio"
          aria-label="Data inizio"
          value={formContext.values.dateStart || null}
          onChange={(value) => {
            if (formContext.values.dateEnd) {
              formContext.setFieldValue('dateStart', value);
              return;
            }

            formContext.setValues({
              ...formContext.values,
              dateStart: value,
              dateEnd: value,
            });
          }}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dateStart"
              fullWidth
              error={formContext.touched?.dateStart && Boolean(formContext.errors?.dateStart)}
              helperText={formContext.errors?.dateStart}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data fine"
          aria-label="Data fine"
          value={formContext.values.dateEnd || null}
          onChange={(value) => formContext.setFieldValue('dateEnd', value)}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dateEnd"
              fullWidth
              error={formContext.touched?.dateEnd && Boolean(formContext.errors?.dateEnd)}
              helperText={formContext.errors?.dateEnd}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="ID Ansc"
          label="ID Ansc"
          id="idAnscNotification"
          name="idAnscNotification"
          type="text"
          variant="outlined"
          value={formContext.values.idAnscNotification || ''}
          fullWidth
          onChange={formContext.handleChange}
          error={
            formContext.touched.idAnscNotification && Boolean(formContext.errors.idAnscNotification)
          }
          helperText={formContext.errors.idAnscNotification}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <ListTypeContent
          value={formContext.values.typeContent || ''}
          error={Boolean(formContext.errors.typeContent) && formContext.touched.typeContent}
          onChange={onChangeTypeContent}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <ListAnsc
          label="Stato bozza delle notifiche"
          idDominio="102"
          value={formContext.values?.stateNotification || ''}
          onChange={handleStateNotification}
          error={
            Boolean(formContext.errors.stateNotification) && formContext.touched.stateNotification
          }
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <ListAnsc
          label="Genere notifiche"
          idDominio="101"
          value={formContext.values?.typeNotifications || ''}
          onChange={handleTypeNotifications}
          error={
            Boolean(formContext.errors.typeNotifications) && formContext.touched.typeNotifications
          }
        />
      </Grid>
      <Grid item container spacing={2} xs={12} justifyContent="space-between" display="flex">
        <Grid item container spacing={2} xs={12} justifyContent="flex-end" display="flex">
          <Grid item xs={12} md={2}>
            <PmiButton
              variant="contained"
              color="secondary"
              fullWidth
              onClick={() => formContext.resetForm()}
            >
              Pulisci
            </PmiButton>
          </Grid>
          <Grid item xs={12} md={2}>
            <PmiButton variant="contained" color="secondary" fullWidth type="submit">
              Cerca
            </PmiButton>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

FormFilter.displayName =
  'Research notifications - Filters component - AccordionFilterNotifications - Form Filter component';

export default FormFilter;
